import React from "react";
import { FaBriefcase, FaBuilding } from "react-icons/fa";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import ImageBanner from "../../components/ImageBanner";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import ServiceStandardsSection from "../../components/service-page/ServiceStandardsSection";
import ServiceProcessSection from "../../components/service-page/ServiceProcessSection";
import ServiceIndustriesSection from "../../components/service-page/ServiceIndustriesSection";
import WhyChooseCarousel, {
  toWhyChooseReasons,
} from "../../components/WhyChooseCarousel";
import { homeIcons } from "../Home/homeIcons";
import "../../styles/brand.css";
import {
  finalCtaContent,
  heroContent,
  industriesContent,
  processContent,
  servicesContent,
  sustainabilitySeo,
  whyChooseContent,
} from "./sustainabilityContent";

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}${sustainabilitySeo.slug}`;

/* the shared registry covers five of the seven sectors; the two this document
   adds are kept local rather than widening a registry the whole site shares */
const industryIcons = {
  ...homeIcons,
  corporate: FaBuilding,
  service: FaBriefcase,
};

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: heroContent.h1,
    description: sustainabilitySeo.description,
    url: CANONICAL,
    serviceType: "Sustainability and ESG consulting",
    provider: { "@type": "Organization", name: "MBA Solutions", url: SITE_URL },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: servicesContent.title,
      itemListElement: servicesContent.standards.map((standard) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: standard.title },
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: `${SITE_URL}/services`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Sustainability & ESG Services",
        item: CANONICAL,
      },
    ],
  },
];

const SustainabilityEsgServices = () => (
  <Layout
    title={sustainabilitySeo.title}
    description={sustainabilitySeo.description}
    keywords="sustainability consulting, ESG consulting, EcoVadis preparation, GRI reporting, SA8000 certification, social accountability, sustainability strategy, MBA Solutions"
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="sustainability-page brand-page bg-white">
      <ImageBanner
        src="/assets/banners/Sustainability&ESG-Services -banner.png"
        alt="Sustainability & ESG Services — MBA Solutions"
        width={1149}
        height={451}
        whole
      />
      <PageIntro
        id="sustainability-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <ServiceStandardsSection
        id="sustainability-services-heading"
        title={servicesContent.title}
        standards={servicesContent.standards}
      />
      <ServiceProcessSection
        id="sustainability-process-heading"
        title={processContent.title}
        steps={processContent.steps}
      />
      <ServiceIndustriesSection
        id="sustainability-industries-heading"
        title={industriesContent.title}
        intro={industriesContent.intro}
        industries={industriesContent.industries}
        icons={industryIcons}
      />
      <WhyChooseCarousel
        id="sustainability-why-choose-heading"
        title={whyChooseContent.title}
        reasons={toWhyChooseReasons(whyChooseContent.reasons)}
        tone="light"
      />
      <FinalCtaPanel
        id="sustainability-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
);

export default SustainabilityEsgServices;
